import Vue from 'vue';

export default function Storage(props) {
  const values = Vue.observable({});

  props.forEach((prop) => {
    let key;
    let storage;
    let defaultValue;

    try {
      if (prop instanceof Object) {
        key = prop.key;
        defaultValue = prop.defaultValue;
        storage = prop.session ? window.sessionStorage : window.localStorage;
      } else {
        key = prop;
        storage = window.localStorage;
      }
    } catch (ignore) {
      // In case the sessionStorage / localStorage is blocked
    }

    // Try to set initial value from proper storage
    try {
      const storedValue = storage?.getItem(key);

      if (storedValue === null) {
        Vue.set(values, key, defaultValue);
      } else {
        Vue.set(values, key, JSON.parse(storedValue));
      }
    } catch (e) {
      Vue.set(values, key, defaultValue);
    }

    Object.defineProperty(this, key, {
      get() {
        return values[key];
      },
      set(value) {
        values[key] = value;
        storage?.setItem(key, JSON.stringify(value));
      },
    });
  });
}
